import SpecialIntructionsTooltip from 'components/summary/SpecialInstructionsTooltip/styled';

export default SpecialIntructionsTooltip;
